export const searchForm = document.querySelector('.search-form');
export const searchHeadline = document.querySelector('.search-headline');
export const searchResult = document.querySelector('.search-result');
export const errorMessage = document.querySelector('.error-message');
export const formLoader = document.querySelector('.form-loader');
